<template>
  <nav class="top-nav">
  <div class="social-links">
    <a class="social-link">Made By prichan_qaq </a>
    <a href="https://www.instagram.com/prichan_qaq" target="_blank" class="social-link">Instagram</a>
    <a href="https://www.youtube.com/@prichan_qaq" target="_blank" class="social-link">YouTube</a>
  </div>
  </nav>
  <img alt="Vue logo" src="./assets/prichan.png" />
  <HelloWorld msg="Welcome to Your Vue.js App" />
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
};
</script>

<style>
#app {
  background-image: url('@/assets/kirakirashiro19.png');
  background-size: cover;
  background-position: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&display=swap');

.social-links {
  /* 可以根據需要調整位置 */
  position: fixed;
  top: 10px;
  right: 20px;
  z-index: 1000;
}

.social-link {
  #color: #e4ad9d;
  #color: #eeb8b8;
  #color: #e098ae;
  color: #efbad6;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
  text-decoration: none;
  #font-style: normal;
  margin-left: 15px;
  font-size: 18px;
  font-weight: bold;
  font-family: "EB Garamond", serif;
}

.social-link:hover {
  /* 如果你想要一些懸停效果，可以在這裡添加 */
  opacity: 0.7;
}

@media (max-width: 380px) {
  .social-link {
    font-size: 17px;
    margin-left: 8px;
  }
}

.top-nav {
  #background-color: #FFE4E1; /* 淡粉紅色背景 */
  #background-color: #FFFFFF; /* 淡粉紅色背景 */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 1) , rgba(255, 255, 255, 0.8));

  padding: 20px 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  #opacity: 0.9;
}
</style>

